import { wixAxios } from '../../utils/wix-axios';
import { GetSettingsResponseType, SetSettingGroupStatusRequest } from './types';
import { ChannelFilter } from '../../consts/channel-filter';

export const getUserSettings = async (msid: string, locale: string = 'en'): Promise<GetSettingsResponseType> => {
  return wixAxios
    .get(`/_api/ping/settings/settings/root.site=${msid}?channel=ALL&locale=${locale}`)
    .then(response => response.data);
};

export const setUserSettings = async (msid: string, channel: ChannelFilter, mute: boolean, groupKey?: string): Promise<void> => {
  let setData = {
    topicPrefix: `root.site=${msid}`,
    channel,
    settingsData: { mute }
  };
  if (groupKey) {
    setData['settingGroup'] = groupKey;
  }
  const request = {
    setData: [
      setData
    ]
  } as SetSettingGroupStatusRequest;
  return wixAxios
    .post(`/_api/ping/settings/settings`, request)
    .then(response => response.data);
};
